import './App.css';
import { ChakraProvider, Box, Container } from '@chakra-ui/react'
import Header from './components/Header';
import SeoDescription from './components/SeoDescription';
import Body from './components/Body';
import Footer from './components/Footer';
import theme from './theme';
import FloatingContactButton from './components/FloatingContactButton';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Box minH="100vh" display="flex" flexDirection="column">
        <Header />
        <SeoDescription />
        <Container maxW="container.xl" flex="1" py={8}>
          <Body />
        </Container>
        <Footer />
        <FloatingContactButton />
      </Box>
    </ChakraProvider>
  );
}

export default App;
